import { LESS_512_MEDIA_QUERY } from '../../../../consts/adaptive';

export const styles = {
    container: {
        maxWidth: 1264,
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column'
    },
    header: {
        width: '100%',
        height: 144,
        marginBottom: 20
    },
    content: {
        display: 'flex',
    },
    filters: {
        width: 224,
        flexShrink: '0'
    },
    main: {
        width: '100%',
        padding: '0 12px',
        display: 'flex',
        flexDirection: 'column',
    },
    reviewCard: {
        width: '100%',
        height: 180,
        marginBottom: 18,
        padding: 20,
        borderRadius: '8px',
        boxSizing: 'border-box',
        backgroundColor: 'whitesmoke'
    },
    reviewHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 20
    },
    circle: {
        height: 45,
        width: 45,
        borderRadius: '50%',
        marginRight: 10
    },
    title: {
        height: 26,
        width: '40%',
    },
    textLine: {
        height: 8,
        width: '75%',
        marginBottom: 10
    },

    [LESS_512_MEDIA_QUERY]: {
        filters: {
            display: 'none'
        },
        reviewCard: {
            height: 120,
        },
    }
};

export type ComponentJSSClasses = typeof styles;
